// apps/web/src/main.tsx.md final composition.
import './styles/fonts.css';
import './styles/colors_and_type.css';
import './styles/tokens.css';
import './features/commercial-proposals/sheet/customer-sheet.css';
import './features/commercial-proposals/sheet/customer-sheet-footer.css';
import './features/logistics-calculations/sheet/logistics-calculation-sheet.css';
import './features/logistics-calculations/sheet/logistics-calculation-workspace.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router/dom';
import { ApiClientProvider } from '@magimp/shared-hooks';
import { webApiClient } from './api/client.js';
import { router } from './router/index.js';
import { useThemeStore } from './stores/theme.js';
import { queryClient } from './queryClient.js';
import { subscribeUserCacheReset } from './auth/userCacheReset.js';
import { startAuthEventsListener } from './api/authEvents.js';
import { initI18n } from './i18n/index.js';

// Apply initial theme attribute BEFORE React mounts to avoid flash.
document.documentElement.setAttribute('data-theme', useThemeStore.getState().theme);

// WHY: clear user-scoped React Query data on identity change. Logout/login
// in the same tab must not let a fresh session read still-fresh cached rows
// belonging to the prior user (the server's row-level filter would not have
// re-run yet within `staleTime`).
subscribeUserCacheReset(queryClient);

// Cross-tab session-lost propagation. Idempotent and module-level so a
// session-lost event arriving at any tab in this browser profile clears
// local auth state without each tab firing its own /auth/refresh.
startAuthEventsListener();

void initI18n().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <ApiClientProvider client={webApiClient}>
          <RouterProvider router={router} />
        </ApiClientProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
});
